import React, { useEffect, useRef, useState } from 'react';

import aircanada from '../assets/partners/air-canada-color.png';
import airchina from '../assets/partners/air-china-color.png';
import britishairways from '../assets/partners/british-airways-color.png';
import cathaypacific from '../assets/partners/cathay-pacific-color.png';
import cmacgm from '../assets/partners/cma-cgm-color.png';
import delta from '../assets/partners/delta-airlines-color.png';
import maersk from '../assets/partners/maersk-color.png';
import oocl from '../assets/partners/oocl-color.png';
import yangming from '../assets/partners/yang-ming-color.png';


const TypewriterText = ({ text, isActive, delay = 0 }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const hasCompleted = useRef(false);

  useEffect(() => {
    if (!isActive) {
      if (!hasCompleted.current) {
        setDisplayedText('');
        setCurrentIndex(0);
      }
      return;
    }

    if (!hasCompleted.current && currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(text.slice(0, currentIndex + 1));
        setCurrentIndex(currentIndex + 1);
      }, currentIndex === 0 ? delay : 90);

      return () => clearTimeout(timeout);
    }
  }, [isActive, currentIndex, text, delay]);

  useEffect(() => {
    if (currentIndex === text.length) {
      hasCompleted.current = true;
    }
  }, [currentIndex, text]);

  return (
    <span>
      {displayedText}
      {isActive && currentIndex < text.length && (
        <span className="animate-pulse">|</span>
      )}
    </span>
  );
};


const logos = [
  aircanada,
  airchina,
  britishairways,
  cathaypacific,
  cmacgm,
  delta,
  maersk,
  oocl,
  yangming,
];

const PoweredBy = () => {

  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);



  return (
    <section 
      ref={sectionRef} 
      className="w-full text-white relative py-8 sm:py-12"
    >
      <div className="text-center min-h-[3rem] sm:min-h-[4rem]">
        <h2 className="text-3xl sm:text-4xl font-bold lg:text-6xl">
          {inView && (
            <TypewriterText 
              text="Our Global Network" 
              isActive={inView} 
              delay={0} 
            />
          )}
        </h2>
      </div>
      
      <div className="overflow-hidden whitespace-nowrap mt-6 sm:mt-8">
        <div className="inline-flex w-max animate-marquee pointer-events-none">
          {[...logos, ...logos].map((logo, index) => (
            <div key={index} className="inline-flex items-center justify-center mx-4 sm:mx-8">
              <img
                src={logo}
                alt={`Partner ${index + 1}`}
                className="w-20 h-18 sm:w-24 sm:h-24 object-contain"
              />
            </div>
          ))}
        </div>
      </div>
      
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee {
            display: inline-flex;
            animation: marquee 15s linear infinite;
          }
        `}
      </style>
    </section>
  );
};

export default PoweredBy;